// extracted by mini-css-extract-plugin
module.exports = {"styledBrand":"BrandOverlay_styledBrand__P82Sj","styledOverlay":"BrandOverlay_styledOverlay__hDMtA","styledImage":"BrandOverlay_styledImage__lzoMl"};